<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/yZRMmU/images/cover.jpg?1699583446267" alt="This image is the cover for the book Seasonal Plant Dyes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Seasonal Plant Dyes
      </h1>
      <p class="bookDescription body article font2">
        <b>“Fascinating and well-illustrated . . . Hall has in the main selected plants which do not require excessively arcane procedures to produce exquisite colors.” —<i>AboutMyGeneration</i></b><br/><br/>This beautifully illustrated book takes you on a botanical journey through the year, showing you how to create colorful and environmentally friendly plant dyes. You’ll learn sustainable methods of growing and harvesting plants; the tools and techniques required to extract dye; which fabrics and yarns to choose; and the simple method of using soy milk as a fixative, to ensure rich and long-lasting colors. <br/><br/>The book includes easy-to-follow tutorials explaining how to make four stunning pieces using seasonal plant dyes: a linen cushion cover, embroidered picnic blanket, hot water bottle cozy, and quilt.<br/><br/><b>“The new book <i>Seasonal Plant Dyes</i> by Alicia Hall walks us through the process featuring plants to use at their peak in spring, summer, autumn, and winter to create an array of gorgeous colors and textures only natural dyes can achieve.” —<i>Empress of Dirt</i></b><br/><br/><b>“Some amazing facts about plants . . . Nature fools us all in to thinking yellow flowers would produce various shades of yellow dyes and all leaves would give green dyes of different hues. This is not so! Who would have believed for instance that a dark purple Buddleia flower would produce a dye of buttercup yellow. 104 pages of fascinating information and I can’t wait to try my first dye! A well written book that’s a delightful and interesting read.” —For the Love of Books</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alicia Hall
      </h2>
      
      <p class="authorDescription body article">After discovering plant dyeing in a horticultural book while working as a gardener, Alicia drew on her education in fashion design to experiment with plant dyes and textiles, creating colorful dyes using the plants that grew in the gardens that she worked in. Since growing her passion into a thriving small business, Alicia now spends her time cooking up plant dyes and making textile products in her home studio in the heart of the Wiltshire countryside, where she lives with her husband and son.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword/White Owl
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?60403ee2